import type { JSX } from 'react'

export const DotsIcon = (): JSX.Element => (
  <use href='#dotsIcon' height='100%' width='100%' />
)
